import { runtime } from "../utils/runtime";

export const initEnv = async (): Promise<void> => {
    runtime.isMac = /Macintosh|Mac OS/i.test(window.navigator.userAgent);
    runtime.isWin = /Windows/i.test(window.navigator.userAgent);
};
